
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"8","fill":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.83 4.196L.4 4.2c-.22 0-.4-.18-.4-.4 0-.22.18-.4.4-.39l12.42-.004-2.75-2.72a.407.407 0 010-.57c.16-.15.41-.16.57 0l3.09 3.03c.35.35.36.9.02 1.26l-3.09 3.27c-.16.16-.41.17-.57.02a.408.408 0 01-.02-.57l2.76-2.93z","fill":"currentColor"}})])
      }
    
      }
    